import { Reducer } from '@reduxjs/toolkit';
import { FluxStandardAction } from 'redux-promise-middleware';

export interface ReplitIntegration {
  id: number;
  app_id: string;
  app_url: string;
  user_id: number;
  account_id: number;
}

export interface ReplitIntegrationsResponse {
  integrations: ReplitIntegration[];
  total: number;
}

export interface ReplitAccessTokenResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
}

export type ReplitState = {
  readonly integrations: ReplitIntegration[];
  readonly fetchingIntegrations: boolean;
  readonly fetchingAccessToken: boolean;
  readonly accessTokens: { [key: string]: string };
};

const initialState: ReplitState = {
  integrations: [],
  fetchingIntegrations: false,
  fetchingAccessToken: false,
  accessTokens: {},
};

const reducer: Reducer<ReplitState, FluxStandardAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_REPLIT_INTEGRATIONS_PENDING': {
      return {
        ...state,
        fetchingIntegrations: true,
      };
    }
    case 'FETCH_REPLIT_INTEGRATIONS_REJECTED': {
      return {
        ...state,
        fetchingIntegrations: false,
      };
    }
    case 'FETCH_REPLIT_INTEGRATIONS_FULFILLED': {
      const response: ReplitIntegrationsResponse = action.payload.data;
      return {
        ...state,
        integrations: response.integrations,
        fetchingIntegrations: false,
      };
    }
    case 'FETCH_REPLIT_ACCESS_TOKEN_PENDING': {
      return {
        ...state,
        fetchingAccessToken: true,
      };
    }
    case 'FETCH_REPLIT_ACCESS_TOKEN_REJECTED': {
      return {
        ...state,
        fetchingAccessToken: false,
      };
    }
    case 'FETCH_REPLIT_ACCESS_TOKEN_FULFILLED': {
      const response: ReplitAccessTokenResponse = action.payload.data;
      const tokenKey = action.meta?.tokenKey;
      return {
        ...state,
        fetchingAccessToken: false,
        accessTokens: tokenKey
          ? { ...state.accessTokens, [tokenKey]: response.access_token }
          : state.accessTokens,
      };
    }
  }
  return state;
};

export default reducer;
